import { render } from "./TypeItem.vue?vue&type=template&id=70d7a023&scoped=true"
import script from "./TypeItem.vue?vue&type=script&lang=js"
export * from "./TypeItem.vue?vue&type=script&lang=js"

import "./TypeItem.vue?vue&type=style&index=0&id=70d7a023&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-70d7a023"

export default script